import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import { getUserDirectoryPortalUrl } from "@/v2-backoffice-client/user/UserEntraButton"
import { getUserHubspotContactUrl } from "@/v2-backoffice-client/user/UserHubspotButton"
import { buildMixpanelUserActivityUrl } from "@/v2-backoffice-client/user/view/user.view.utils"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"

export type UserExternalToolMenuItemsProps = {
  user: UserFragment | null | undefined
}

// The "Open in …" trio every user action menu offers: Mixpanel (activity
// feed by email), Entra (identity by object id) and HubSpot (the linked
// CRM contact). One component so the next external tool lands in every
// menu at once. Each item disables when the user lacks the handle it
// needs — no email, no identity, or not linked to a contact yet.
function UserExternalToolMenuItems(props: UserExternalToolMenuItemsProps) {
  const { user } = props

  const mixpanelUrl = user?.Email
    ? buildMixpanelUserActivityUrl(user.Email)
    : undefined
  const entraUrl = user?.AzureID ? getUserDirectoryPortalUrl(user) : undefined
  const hubspotUrl = getUserHubspotContactUrl(user?.Contact?.ExternalContactId)

  return (
    <>
      <ActionMenu.LinkItem
        iconSrc="mixpanel"
        disabled={!mixpanelUrl}
        to={mixpanelUrl ?? ""}
        external
      >
        Open in Mixpanel
      </ActionMenu.LinkItem>

      <ActionMenu.LinkItem
        iconSrc="entra"
        disabled={!entraUrl}
        to={entraUrl ?? ""}
        external
      >
        Open in Entra
      </ActionMenu.LinkItem>

      <ActionMenu.LinkItem
        iconSrc="hubspot"
        disabled={!hubspotUrl}
        to={hubspotUrl ?? ""}
        external
      >
        Open in HubSpot
      </ActionMenu.LinkItem>
    </>
  )
}

export default UserExternalToolMenuItems
